import { render } from "./ModalPin.vue?vue&type=template&id=c5c49138"
import script from "./ModalPin.vue?vue&type=script&lang=js"
export * from "./ModalPin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__